<template>
  <li
    class="nav-item"
    :class="{ 'sidebar-group-active active': isActive }"
  >
    <b-link
      class="nav-link d-flex align-items-center"
      v-bind="linkProps"
    >
      <img
        v-if="item.tabIcon && item.tabIconActive"
        :src="isActive ? item.tabIconActive : item.tabIcon"
        :alt="item.title"
        class="nav-tab-svg-icon"
      >
      <feather-icon
        v-else-if="item.icon"
        size="14"
        :icon="item.icon"
      />
      <span>{{ item.title }}</span>
    </b-link>
  </li>
</template>

<script>
import { BLink } from 'bootstrap-vue'
import { useUtils as useI18nUtils } from '@core/libs/i18n'
import { useUtils as useAclUtils } from '@core/libs/acl'
import { navLinkProps } from '@core/layouts/utils'
import useHorizontalNavMenuHeaderLink from './useHorizontalNavMenuHeaderLink'
import mixinHorizontalNavMenuHeaderLink from './mixinHorizontalNavMenuHeaderLink'

export default {
  components: {
    BLink,
  },
  mixins: [mixinHorizontalNavMenuHeaderLink],
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const { isActive, updateIsActive } = useHorizontalNavMenuHeaderLink(
      props.item,
    )

    const { t } = useI18nUtils()
    const { canViewHorizontalNavMenuHeaderLink } = useAclUtils()
    const linkProps = navLinkProps(props.item)

    return {
      isActive,
      updateIsActive,
      linkProps,
      canViewHorizontalNavMenuHeaderLink,
      t,
    }
  },
}
</script>

<style scoped>
.nav-tab-svg-icon {
  width: 22px;
  height: auto;
  max-height: 22px;
  margin-right: 0.5rem;
  object-fit: contain;
  flex-shrink: 0;
}
</style>
